module.exports = __webpack_public_path__ + "static/media/59.490528a1.jpg";